<template>
  <div>
    <v-card flat width="100%">
      <v-form v-model="valid" ref="form" :disabled="readOnly">
        <v-container class="px-6 pt-6 purtrak-scrollable" fluid style="height:calc(100vh - 206px)">
          <v-row>
            <v-col cols="12" sm="7" md="5">
              <v-row>
                <v-col>
                  <v-text-field label="Name" v-model="company.name" :rules="[fieldRules.required,fieldRules.maxLength(50)]" :counter="50" outlined dense autocomplete="organization"/>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-text-field label="Address" v-model="company.address" :rules="[fieldRules.maxLength(80)]" :counter="80" outlined dense/>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="8" md="4">
                  <v-text-field label="City" v-model="company.city" :rules="[fieldRules.maxLength(80)]" :counter="80" outlined dense/>
                </v-col>
                <v-col cols="4" md="3">
                  <v-autocomplete label="Province" v-model="company.province" disabled
                            :items="['AB','BC','MB','NB','NL','NS','NT','NU','ON','PE','QC','SK','YT']" outlined dense/>
                </v-col>
                <v-col cols="6" md="5">
                  <v-text-field label="Postal code" v-model="company.postalCode" outlined dense/>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="7">
                  <v-text-field label="Email" v-model="company.email" :rules="[fieldRules.email,fieldRules.maxLength(50)]" :counter="50" outlined dense/>
                </v-col>
                <v-col cols="6" sm="5">
                  <v-text-field label="Phone" v-model="company.phone" :rules="[fieldRules.phone,fieldRules.maxLength(20)]" outlined dense/>
                </v-col>
                <v-col cols="6">
                  <v-text-field label="Business number" v-model="company.businessNumber" :rules="[businessNumber]" :counter="9" outlined dense/>
                </v-col>
              </v-row>
            </v-col>

            <v-col md="3" offset="2" class="text-center" v-if="!$vuetify.breakpoint.mobile">
              <picture-picker v-model="company.logoURL" :size="200" @change="company.logoUpload=company.logoURL"/>
            </v-col>
          </v-row>
        </v-container>
      </v-form>

      <v-divider/>
      <v-card-actions class="pr-6">
        <settings-reset/>
        <v-spacer/>
        <v-btn plain color="primary" @click="load">Reset</v-btn>
        <v-btn color="primary" :disabled="!dirty || readOnly" :loading="saving" @click="save">Save</v-btn>
      </v-card-actions>
    </v-card>

    <v-snackbar :timeout="10000" v-model="showReadOnly" color="warning" top app>
      You have read only access to distillery information.
      <v-btn plain @click="showReadOnly=false">Close</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import SettingsReset from '@/views/settings/SettingsReset';

export default {
  name: 'SettingsDistillery',
  components: {SettingsReset},
  data() {
    return {
      company: {province:'ON'},
      valid: true,
      dirty: false,
      saving: false,
      businessNumber: v => {
        const pattern = /([0-9]){9}/
        return !v || pattern.test(v) || 'Invalid business number'
      },
      connect: 0,
      showReadOnly: false
    }
  },
  computed: {
    readOnly() {
      return this.$store.getters.company && !this.$store.getters.company.permissions.includes('config.write');
    }
  },
  mounted() {
    this.load();
  },
  watch: {
    company: {
      handler() {this.dirty = true; this.$emit('dirty',true)},
      immediate: true,
      deep: true
    }
  },
  methods: {
    async load() {
      const results = await this.$apiCall(`query SettingsDistillery {
                                            company {name,address,city,province,postalCode,email,phone,businessNumber,connectedToAccounting,logoURL,excisePeriodEnd}
                                           }`,
                                          {});
      if (!results.error) {
        this.company = results.data.company;
        this.$nextTick(() => {
          this.dirty = false;
          this.$emit('dirty',false);
        });
      }
      if (this.readOnly)
        this.showReadOnly = true;
    },
    async save() {
      if (!this.$refs.form.validate()) {
        this.$store.commit('setError', {type:'warning',message:`One or more fields is missing or invalid`});
        return;
      }

      this.saving = true;
      // eslint-disable-next-line no-unused-vars
      const {logoURL,connectedToAccounting,province,settings,excisePeriodEnd,...input} = this.company;
      const results = await this.$apiCall(`mutation SettingsDistillery($input: CompanyUpdateInput!) {
                                              companyUpdate(input:$input) {id,name}
                                            }`,
                                          {input:input});
      if (results.error) {
        this.saving = false;
        return;
      }

      const error = await this.$store.dispatch('refreshCompanies');
      if (!error) {
        this.dirty = false;
        this.$emit('dirty',false);
      }
      this.saving = false;
    }
  }
}
</script>